const tpl = (name) => `NDFL3_PROPERTY_DEDUCTIONS/${name}`;

export const INITIALIZE = tpl`INITIALIZE`;

export const SUBMIT = tpl`SUBMIT`;
export const SUBMIT_SUCCESS = tpl`SUBMIT_SUCCESS`;
export const SUBMIT_FAILURE = tpl`SUBMIT_FAILURE`;
